// ----- phase-company-profile-rows-7-9 (Row 7) -----
//
// Shared by every surface that warns about, or reports, a missing authorized
// signatory: the link to the profile's signatory list, and reading the
// server's 422 MissingSignatory refusal.

import { parseApiErrorBody } from '@/api/v2Client';

/**
 * Deep link to a company profile's "Authorized signatories" section. The
 * Company Profile page opens that profile's editor and scrolls to the section.
 */
export function profileSignatoriesHref(profileId: string): string {
  return `/admin/company-profile?edit=${encodeURIComponent(profileId)}&section=signatories`;
}

/**
 * The profile id named by a 422 MissingSignatory refusal, or null when the
 * error is anything else.
 */
export function missingSignatoryProfileId(err: unknown): string | null {
  const body = parseApiErrorBody(err);
  if (body?.error !== 'MissingSignatory') return null;
  const data = body.data as { companyProfileId?: unknown } | undefined;
  return typeof data?.companyProfileId === 'string' ? data.companyProfileId : null;
}
